import {Operation} from '@yandex-data-ui/cloud-schemas/build/models/operations';

import {sleep} from './sleep';

export function waitOperationFactory(
    getOperation: (params: {operationId: string}) => Operation | Promise<Operation>,
) {
    return async function wait<O extends Operation>(promise: O | Promise<O>) {
        let operation = await promise;

        while (!operation.done) {
            await sleep(2000); // 2 sec

            operation = (await getOperation({operationId: operation.id})) as O;
        }

        if (operation.error) {
            throw operation.error;
        }

        if (!operation.response) {
            throw new Error('No response data');
        }

        return operation.response;
    };
}
